<template>
	<div class="display-flex flex-column" v-if="isPdfViewer">
		<div class="pdf-header display-flex flex-align-center flex-justify-space-between px-4">Document Viewer</div>
		<Col class="px-4 mt-2">
			<SettingSwitch title="Multiple files" :switchValue.sync="isMultiFiles" />
			<WidgetSettingsItem class="mt-2" noSwitchButton :item="isMultiFiles ? multipleFilesSettingItem : pdfSettingItem" />
		</Col>
	</div>

	<!-- Placeholder -->
	<div v-else class="flex-centerize placeholder-container flex-column">
		<SIcon name="select-a-block" :width="57" class="mb-6" />
		Select a Block
	</div>
</template>

<script>
import { MULTI_FILE_VIEWER } from '@/utils/widget-service.const';
import { widgetMetadata } from '@/store/modules/widgetEditor/getters';
import { setWidgetOption } from '@/store/modules/widgetEditor/actions';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import SettingSwitch from '@/components/BlockEditorWidget/FieldSettings/WidgetSettings/SettingSwitch.vue';
import WidgetSettingsItem from '@/components/BlockEditorWidget/FieldSettings/WidgetSettings/WidgetSettingsItem.vue';
import FileViewerSettings from '@/components/BlockEditorWidget/FieldSettings/WidgetSettings/FileViewerSettings.vue';
import MultiFileViewerSettings from '@/components/BlockEditorWidget/FieldSettings/WidgetSettings/MultiFileViewerSettings.vue';

export default {
	name: 'BlockEditorWidgetPlaceHolder',
	components: { SettingSwitch, WidgetSettingsItem },
	props: {
		isPdfViewer: { type: Boolean },
	},
	computed: {
		...mapGettersShorthand({ widgetMetadata }),
		isMultiFiles: {
			get() {
				return this.multiFileViewerOptions.enabled;
			},
			set(value) {
				if (value) {
					this.setWidgetOption({ key: 'file_viewer', value: { value: '', active: true } });
					const newMultiFileViewerValue = { value: '', enabled: true };
					this.setWidgetOption({ key: MULTI_FILE_VIEWER, value: newMultiFileViewerValue });
				} else {
					const newMultiFileViewerValue = { value: '', enabled: false };
					this.setWidgetOption({ key: MULTI_FILE_VIEWER, value: newMultiFileViewerValue });
				}
			},
		},
		widgetOptions() {
			return this.widgetMetadata.options;
		},
		multiFileViewerOptions() {
			return this.widgetOptions[MULTI_FILE_VIEWER] || { enabled: false, value: undefined };
		},
	},
	methods: {
		...mapActionsShorthand({ setWidgetOption }),
	},
	data() {
		return {
			pdfSettingItem: {
				key: 'file_viewer',
				label: 'Choose PDF file',
				editComponent: FileViewerSettings,
				description: '(Supported files: .pdf Files)',
			},
			multipleFilesSettingItem: {
				key: MULTI_FILE_VIEWER,
				label: 'Choose a table of files',
				editComponent: MultiFileViewerSettings,
				description: `Must include a column called 'src' containing file URLs. Optionally include a 'title' column with file names. All other columns will not be displayed.`,
			},
		};
	},
};
</script>

<style scoped lang="scss">
.pdf-header {
	height: 60px;
	font-size: 16px;
	font-weight: bold;
	text-transform: capitalize;
	color: var(--primary-font-color);
	border-bottom: 1px solid var(--border-color);
}
.placeholder-container {
	height: 300px;
	font-size: 16px;
	font-weight: 600 !important;
	color: var(--primary-font-color);
}
</style>
